import { useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router";
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "@illustraclass/ui";
import { useAuth } from "../hooks/useAuth";
import { decodeJwtPayload, parseHashParams } from "../lib/jwt-decode";

export function SetPasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const {
    setPasswordFromInvitation,
    setUserFromToken,
    isLoading,
    error,
    clearError,
  } = useAuth();
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  useEffect(() => {
    const hashParams = parseHashParams(location.hash);
    const token = hashParams["token"] ?? searchParams.get("token");
    if (token) {
      try {
        const payload = decodeJwtPayload(token);
        setUserFromToken(token, {
          id: payload.sub,
          email: payload.email,
          displayName: "",
          role: payload.role,
        });
      } catch {
        void navigate("/login");
      }
    }
  }, [location.hash, searchParams, setUserFromToken, navigate]);

  async function handleSubmit(e: React.SyntheticEvent) {
    e.preventDefault();
    try {
      await setPasswordFromInvitation(password, passwordConfirm);
      void navigate("/dashboard");
    } catch {
      // L'erreur est gérée dans le store
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Définir votre mot de passe</CardTitle>
          <CardDescription>
            Choisissez un mot de passe pour votre compte IllustraClass
          </CardDescription>
        </CardHeader>
        <CardContent>
          {error && (
            <div
              role="alert"
              className="mb-4 rounded-md bg-destructive/10 p-3 text-sm text-destructive"
            >
              {error}
              <button
                onClick={() => {
                  clearError();
                }}
                className="ml-2 underline"
                type="button"
              >
                Fermer
              </button>
            </div>
          )}

          <form
            onSubmit={(e) => {
              void handleSubmit(e);
            }}
            className="space-y-4"
          >
            <div className="space-y-2">
              <Label htmlFor="new-password">Mot de passe</Label>
              <Input
                id="new-password"
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="confirm-password">
                Confirmer le mot de passe
              </Label>
              <Input
                id="confirm-password"
                type="password"
                value={passwordConfirm}
                onChange={(e) => {
                  setPasswordConfirm(e.target.value);
                }}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>
            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? "Enregistrement…" : "Définir le mot de passe"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </main>
  );
}
